import {BaseConverter} from "../../base/converters/base-converter.converter";
import {DraftsResearchModel} from "../models/drafts-research.model";
import {DraftsResearch} from "../../shared/DTO/draftsResearch";
import {Injectable} from "@angular/core";
import {DraftsResearchFilter1Converter} from "./drafts-research-filter1.converter";
import {DraftsResearchFilterConverter} from "./drafts-research-filter.converter";

@Injectable()
export class DraftsResearchConverter extends BaseConverter<DraftsResearchModel, DraftsResearch> {

  constructor(private draftsResearchFilter1Converter: DraftsResearchFilter1Converter, private draftsResearchFilterConverter: DraftsResearchFilterConverter) {
    super();
  }

  convertToDto(model: DraftsResearchModel): DraftsResearch {
    if (!model) {
      return;
    }
    return {
      filter: this.draftsResearchFilterConverter.convertToDto(model.filter),
      options: this.draftsResearchFilter1Converter.convertToDto(model.options)
    };
  }

  convertToModel(dto: DraftsResearch): DraftsResearchModel {
    if (!dto) {
      return;
    }
    let model: DraftsResearchModel = new DraftsResearchModel();
    model.filter = this.draftsResearchFilterConverter.convertToModel(dto.filter);
    model.options = this.draftsResearchFilter1Converter.convertToModel(dto.options);
    return model;
  }

}
